import { Component, OnDestroy, OnInit } from '@angular/core';
import { MdDialog } from '@angular/material';
import { Observable } from 'rxjs/observable';
import { Subscription } from 'rxjs/Subscription';

import { User } from '../../models/user';
import { UserService } from '../../services/user.service';
import { AddUserComponent } from '../add-user/add-user.component';
import { UpdateUserComponent } from '../update-user/update-user.component';

@Component({
  selector: 'app-users',
  templateUrl: './users.component.html',
  styleUrls: ['./users.component.scss']
})
export class UsersComponent implements OnInit, OnDestroy {
	private subscriptionManager: Subscription;
	public users: Observable<User[]>;

  constructor(private dialog: MdDialog,
							private userService: UserService) {
		this.subscriptionManager = new Subscription();

		this.getUsers();
	}

  ngOnInit() {
  }

	ngOnDestroy() {
		this.subscriptionManager.unsubscribe();
	}

	public async getUsers() {
		this.users = await this.userService.getUsers();
	}

	public add(): void {
		let dialogRef = this.dialog.open(AddUserComponent, {
			width: '300px'
		});
	}

	public update(user: User): void {
		let dialogRef = this.dialog.open(UpdateUserComponent, {
			width: '300px'
		});

		dialogRef.componentInstance.updateForm(user);
	}
}



// WEBPACK FOOTER //
// C:/Source/Ecim/Ecim.Web/src/app/components/users/users.component.ts